import React, { useState } from "react";
import "../../styles/ExperienceField.css";

const ExperienceField = (props) => {
    const [isOpen, setIsOpen] = useState(false);

    const toggleOpen = () => {
        setIsOpen(!isOpen);
    };

    return(
        <div className={`experience-field ${props.className || ''}`}>
            <div className="experience-header" onClick={toggleOpen}>
                <div className="logo-date">
                    <img src={props.src} alt={props.alt} />
                    <p>{props.date}</p>
                </div>
                <h1>{props.title}</h1>
                <button className="toggle-button" aria-label="Toggle details">
                    {isOpen ? '−' : '+'}
                </button>
            </div>
            <ul className={isOpen ? 'open' : ''}>
                {props.items && props.items.map((item, index) => (
                    <li key={index}>{item}</li>
                ))}
            </ul>
        </div>
    );
}

export default ExperienceField